var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		'floating-notification',
		_vm.disabled && 'is-disabled',
		..._vm.stateClassList
	],attrs:{"data-testid":"floating-notification"}},[_c('div',{class:[
			'floating-notification__shell-msg',
			_vm.isExpanded && 'is-open'
		],attrs:{"data-testid":"floating-notification-msg"}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.messageText)+" ")]})],2),_c('button',{staticClass:"floating-notification__trigger",attrs:{"aria-label":_vm.ariaLabel,"data-testid":"floating-notification-trigger"},on:{"click":_vm.onClick}},[_c('i',{class:['icon', _vm.iconClassName]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }